export const wipExitAlertCallback = (event: Event) => {
  // using all 3 methods of beforeunload activation to cover most browser cases
  event.preventDefault();
  // eslint-disable-next-line no-param-reassign
  event.returnValue = true;
  return '';
};
